import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

import { loadCSS, loadJS } from "../../utils/loadAssets";
import Loader from "../users/components/PageLoader"

import Home from "./Home";
import Privacypolicy from "./Privacy";
import Deleteaccount from "./Deleteaccount";

export default function UserApp() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAssets = async () => {
      await Promise.all([

      ]);

  
      setLoading(false);
    };

    loadAssets();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fff",
        }}
      >
        <Loader/>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacypolicy" element={<Privacypolicy />} />
      <Route path="/deleteaccount" element={<Deleteaccount />} />
     
    </Routes>
  );
}
